import { StyledTextInput } from 'components/common/inputs/StyledInput';
import { Row } from 'components/wrappers/grid/FlexWrapper';
import { Button } from 'ui-kit/components/buttons/Button';
import { Select } from 'ui-kit/components/Select/Select';
import { addUserModalStore } from 'stores/modals';
import { Modal } from 'ui-kit/components/Modal';
import { useTranslation } from 'react-i18next';
import { type ReactFCC } from 'types/react';
import { useUnit } from 'effector-react';

import { Container } from './styles';

export const AddUserModal: ReactFCC = () => {
    const { closeModal, modal } = addUserModalStore;
    const { t } = useTranslation();

    const [_, { title }] = useUnit(modal);

    const handleClose = () => {
        closeModal();
    };

    return (
        <Modal
            customFooter={
                <Row justifyEnd gap="16px">
                    <Button variant="secondary">Cancel</Button>
                    <Button variant="primary">Invite user</Button>
                </Row>
            }
            onClose={handleClose}
            title={title}
            visible
        >
            <Container>
                <StyledTextInput placeholder="Enter first user name" title="First name" />
                <StyledTextInput placeholder="Enter last user name" title="Last name" />
                <StyledTextInput placeholder="example@gmail.com" title="Email" />
                <div>{t('Role')}</div>
                <Select
                    options={[
                        { label: 'Admin', value: 'admin' },
                        { label: 'User', value: 'user' }
                    ]}
                />
            </Container>
        </Modal>
    );
};
